import React, { useEffect } from 'react';
import DiwaliFireworks from './DiwaliFireworks';
import MarigoldRain from './MarigoldRain';
import { CornerDiyas } from './Diyas';
import './diwali.css';

// Theme runs automatically until 25 Nov 2026, 11:59 PM IST
export const DIWALI_END = new Date('2026-11-25T23:59:59+05:30');
export const isDiwaliPeriod = () => Date.now() <= DIWALI_END.getTime();

const DiwaliTheme = ({ children }) => {
  const active = isDiwaliPeriod();

  useEffect(() => {
    if (!active) return undefined;
    document.documentElement.classList.add('diwali-theme');
    const timer = setTimeout(() => {
      document.documentElement.classList.remove('diwali-theme');
      window.location.reload();
    }, Math.min(DIWALI_END.getTime() - Date.now() + 1000, 2147483647));
    return () => {
      clearTimeout(timer);
      document.documentElement.classList.remove('diwali-theme');
    };
  }, [active]);

  if (!active) return <>{children}</>;

  return (
    <>
      <div className="diwali-overlay-root" data-testid="diwali-theme-overlay">
        <DiwaliFireworks />
        <MarigoldRain />
        <CornerDiyas />
      </div>
      {children}
    </>
  );
};

export default DiwaliTheme;
